// Global Types
import type {
  $Translate,
} from 'common.language';

// Global Components
import * as React from 'react';

// Helpers
import config from '../../../config';

// Types
type $Props = $Translate;

const FooterView = function ({
  t,
}: $Props) {
  return (
    <footer className={'footer-container'}>
      <span>
        &copy;
        {new Date().getFullYear()}
        {' '}
        {'- Regattas.eu'}
      </span>
      <span className={'mx-1 text-muted'}>{'|'}</span>
      <a href={`https://${config.DOMAIN}/page/privacy-policy`}>
        {t('Privacy policy')}
      </a>
      <span className={'mx-1 text-muted'}>{'|'}</span>
      <a href={'mailto:Regattas.eu<info@regattas.eu>?subject=Hello'}>
        {t('Contact')}
      </a>
    </footer>
  );
};

export default FooterView;
